import React, { useEffect } from "react";
import { getFacebookClientId, getjumpCloudClientId, jC_AUTH_URL } from "../../utils/general-config";
import FacebookLogin from "react-facebook-login";
import { useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import AppleSignin from "react-apple-signin-auth";
import { getSignSimpliBaseURL } from "../../services/api-constants";
import Footer from "../../components/footer/component";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GoogleCaptcha from "../sign-up/captcha";

const SignSimpliSignIn = ({
  pwdNavigate,
  signUpNavigate,
  onSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
  setShowLoader,
  setLoginError,
  setLoginErrorMessage,
  AuthenticateJCPartnerUser,
  appleLogin,
  showCaptcha,
  onCaptchaSuccess,
  recaptchaRef,
  loginError,
  loginErrorMessage,
}) => {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  useEffect(() => {
    const cId = params.get("cid");
    if (!!code) {
      setShowLoader("d-block");
      AuthenticateJCPartnerUser(code, cId);
    }
    return; // Exit early if no code
  }, []);
  const jumpCloudLogin = () => {
    setShowLoader("d-block");
    const getJumpCloudClientId = getjumpCloudClientId();
    // console.log("JumpCloud Client ID:", getJumpCloudClientId);
    // console.log("JumpCloud currentDomain ID:", jC_AUTH_URL);
    let defaultURl = "";
    let hostname = window.location.hostname;
    if (hostname.includes("localhost")) {
      defaultURl = "https://localhost:5000";
    } else {
      defaultURl = `https://${hostname}`;
    }

    var redirectUrl = `${defaultURl}/app/account/signin?cid=${getJumpCloudClientId}`;
    const url = `${jC_AUTH_URL}/?client_id=${getJumpCloudClientId}&response_type=code&redirect_uri=${redirectUrl}&state=signsimpli`;

    window.location.href = url;
  };

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_in.ss.description_meta")} />
        <title> {t("page_title.ss.sign_in")} </title>
      </Helmet>
      <section className="main-content !min-h-[calc(100vh-11rem)] min-[1250px]:!pt-3 min-[1400px]:!pt-12 backdrop-blur-[100px] bg-blur-bg-rs font-rethink pb-2">
        <div className="container  mx-auto ">
          <div className="form-wrap-psr relative p-[1px] rounded-xl border-2 bg-rs-border-gradient w-full">
            <div className="rounded-xl py-8 px-4 bg-white shadow-md  min-[1400px]:py-[40px] min-[1400px]:px-[60px]">
              <hgroup className="text-center user-page">
                <h1
                  className="main-headline text-[#16283D] text-2xl md:text-4xl font-rethink mt-0 pb-2.5 !leading-10"
                  style={{ textShadow: "2px 0 0 #16283D" }}
                >
                  {t("sign_in.ps.headline")}
                </h1>
              </hgroup>

              <div className="social-login  justify-between flex-col w-full">
                <div className="flex items-center">
                  <div className="social-login--google w-full mb-0">
                    <button
                      type="button"
                      className="google-login-button text-xs lg:text-sm text-white !bg-[#4181EF] mt-[1px] w-auto !flex items-center justify-center h-[41px] rounded-[5px]"
                      onClick={googleLogin}
                      id="googleBtn"
                    >
                      <div className="bg-white ml-[2px] rounded-l-md">
                        <img
                          src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                          height="20px"
                          width="20px"
                        />
                      </div>
                      <span className="text-sm lg:text-base ml-10 md:ml-10 !font-rethink">
                        {t("sign_in.signin_with_google")}
                      </span>
                    </button>
                  </div>
                  <div className="social-login--facebook !leading-none mb-0 ml-[5px ]">
                    <FacebookLogin
                      appId={getFacebookClientId()}
                      autoLoad={false}
                      fields="name,email"
                      textButton=""
                      callback={responseFacebook}
                      cssClass=""
                      size="!w-[41px] !h-[40px] rtl:!hidden"
                      icon={
                        <img
                          src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                          className="facebook-login-button border border-[#EAEBED] !w-[41px] !h-[40px] rtl:!hidden !relative !rounded-[5px]"
                          id="fbBtn"
                        />
                      }
                    />
                  </div>
                </div>
                {/* <div className="social-login--apple w-full">
                   <AppleSignin
                     className="apple-signin-button"
                     authOptions={{
                       clientId: "com.pdfsimpli.pdfservice",
                       scope: "email name",
                       redirectURI: getSignSimpliBaseURL + "signin-apple",
                       usePopup: true,
                     }}
                     onSuccess={appleLogin}
                     onError={(error) => {
                       console.error("Apple login failed:", error);
                       appleLogin({
                         user: null,
                         authorization: {
                           id_token: null,
                           error: error.message,
                         },
                       });
                     }}
                     uiType="light"
                     buttonExtraChildren={null}
                     style={{ display: "none" }}
                   />
                   <button
                     onClick={() => document.querySelector(".apple-signin-button").click()}
                     className="relative flex items-center justify-center px-2.5 py-2 border border-[#EAEBED] bg-white cursor-pointer rounded-md w-full -mt-[6px]"
                   >
                     <img
                       src={process.env.PUBLIC_URL + "/static/images/apple-icon.svg"}
                       alt="Apple"
                       className="absolute left-3 w-5 h-6"
                     />
                     <span className="text-center w-full ml-5">{t("sign_in.signin_with_apple")}</span>
                   </button>
                 </div>   */}
                <div className="jumpcloud-login">
                  <button
                    type="button"
                    id="jumpcloudBtn"
                    className="jumpcloud-login-button text-white border border-[#EAEBED] rounded-md -mt-[6px]"
                    onClick={jumpCloudLogin}
                  >
                    <div class="bg-white m-px rounded-sm" bis_skin_checked="1">
                      <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
                        <rect x="0.5" y="0.5" width="39" height="39" fill="white" stroke="#002B49" />
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.0857 25.5677C9.37901 25.5677 7.99512 24.112 7.99512 22.3147C7.99512 20.5184 9.37901 19.0616 11.0857 19.0616C11.5668 19.0616 12.0229 19.1783 12.429 19.3844C12.8736 18.162 13.9982 17.2946 15.3155 17.2946C15.43 17.2946 15.5435 17.3018 15.655 17.3143C16.0798 15.3223 17.7698 13.8333 19.791 13.8333C21.3832 13.8333 22.7692 14.7569 23.4939 16.1231C23.8625 15.9596 24.2686 15.868 24.6945 15.868C26.4012 15.868 27.7851 17.3247 27.7851 19.121C27.7851 19.1751 27.7841 19.2303 27.781 19.2834C28.1298 19.1408 28.5078 19.0616 28.9045 19.0616C30.6112 19.0616 31.9951 20.5184 31.9951 22.3147C31.9951 23.9849 30.7997 25.3605 29.2596 25.5459C29.1472 25.5615 29.0191 25.5677 28.9056 25.5677H27.7424C27.7164 24.4827 26.5897 23.5518 24.9819 23.1363C25.5744 22.6323 25.9483 21.8971 25.9483 21.0776C25.9483 19.5573 24.6612 18.3244 23.0732 18.3244C21.4852 18.3244 20.1982 19.5573 20.1982 21.0776C20.1982 21.9002 20.5751 22.6385 21.1728 23.1436C20.3179 23.3685 19.6005 23.7402 19.1163 24.2026C18.7528 23.9912 18.3134 23.8194 17.8219 23.7007C18.3405 23.2706 18.6685 22.6354 18.6685 21.9273C18.6685 20.6319 17.571 19.5813 16.2183 19.5813C14.8646 19.5813 13.7681 20.6319 13.7681 21.9273C13.7681 22.6344 14.0951 23.2685 14.6116 23.6986C13.2735 24.0193 12.3186 24.7305 12.2259 25.5688H11.0868L11.0857 25.5677Z"
                            fill="#002B49"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="24" height="24" fill="white" transform="translate(7.99512 8)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <span>{t("sign_in.ss.sign_in_with_jumpcloud")}</span>
                  </button>
                </div>
              </div>
              <div className="or-container !mt-3 !-mb-2 !font-rethink !text-[#687585] !text-md">
                <span></span> {t("sign_in.or")} <span></span>
              </div>
              <div className="form-text mb-10 mt-2">
                {(passwordError || emailError) && (
                  <p
                    key="pswrdErr"
                    className="bg-red-100 text-center w-full "
                    dangerouslySetInnerHTML={{
                      __html: passwordErrorMsg,
                    }}
                  />
                )}
                    {loginError && <p className="text-center text-red-500">{loginErrorMessage}</p>}
              </div>
              <div className="mx-auto my-2 !max-w-96">
                <div className="">
                  <InputText
                    showLabel={false}
                    id="email"
                    text="Email Address"
                    onChange={onEmailChangeHandler}
                    className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                    value={emailId.trim()}
                    maxLength={100}
                    placeholder={t("sign_in.ps.placeholder_email")}
                  />
                </div>
                <div className="">
                  <InputText
                    showLabel={false}
                    id="password"
                    text="Password"
                    type="password"
                    onChange={onPwdChangeHandler}
                    value={pwd}
                    className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                    onKeyPress={onPasswordKeyPress}
                    placeholder={t("sign_in.ps.placeholder_password")}
                  />
                </div>
                <div className="flex flex-col items-center space-y-3">
                  <div className="check_box flex justify-between items-center w-full px-1 !mt-[6px]">
                    <label className="form-check flex items-center space-x-2 text-sm text-[#424a5c] font-rethink">
                      <input id="checkbox-btn" className="form-check-input" type="checkbox" value="" />
                      <span className="checkmark peer-checked:bg-orange-500">
                        <span className="rtl: mr-2 font-normal text-sm font-rethink">
                          {t("sign_in.ps.remember_me")}
                        </span>
                      </span>
                    </label>
                    <button
                      id="ForgotPassword"
                      className="setCulture text-sm text-[#0f67cb] font-medium decoration-[#0f67cb] underline font-rethink"
                      isLoading={false}
                      disabled={disableBtn}
                      onClick={pwdNavigate}
                    >
                      {t("sign_in.ps.forgot")}
                    </button>
                  </div>
                  {showCaptcha && (
                    <div className="flex flex-row justify-center mt-2" style={{ width: "304px" }}>
                      <GoogleCaptcha onCaptchaSuccess={onCaptchaSuccess} recaptchaRef={recaptchaRef} />
                    </div>
                  )}
                  <div
                    className={`fbn bounce-effect md:relative bottom-0 left-0 bg-white border-gray-300 text-center w-full z-50 ${
                      showCaptcha ? "" : "p-0 md:py-[20px]"
                    }`}
                  >
                    <button
                      id="log-in"
                      className="text-white p-4 w-full leading-[120%] font-rethink tracking-[2%] h:[60px] md:h-[62px] text-lg font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase
                              transition-colors duration-1000 ease-in-out"
                      isLoading={false}
                      disabled={false}
                      type="submit"
                      onClick={onSignIn}
                    >
                      {t("sign_in.btn_cta")}
                    </button>
                  </div>{" "}
                  <p className="mt-4 max-[390px]:mx-[-36px]">
                    {t("sign_in.ps.don't _have_account")}
                    <button
                      id="sign-up-btn"
                      className="setCulture font-normal text-[#0E76FF] hover:text-[#f9593a] mb-[10px] ml-1 text-sm"
                      isLoading={false}
                      disabled={disableBtn}
                      onClick={signUpNavigate}
                    >
                      <span className="mr-1 text-[#0E77FF]">
                        <FontAwesomeIcon icon={faUserCircle} />
                      </span>{" "}
                      <span className="text-[#0E76FF] underline">{t("sign_in.sign_up")}</span>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default SignSimpliSignIn;
